var _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 298,
    viewBox: "0 0 575 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.119 289.676C33.3693 299.437 17.5619 299.437 7.81226 289.676C-1.93742 279.916 -1.93742 264.091 7.81225 254.33L253.547 8.32044C263.296 -1.44014 279.104 -1.44016 288.854 8.32043C290.242 9.71052 291.433 11.2236 292.426 12.8247L408.484 129.012L528.881 8.47984C538.631 -1.28075 554.438 -1.28075 564.188 8.47984C573.938 18.2404 573.938 34.0655 564.188 43.826L426.492 181.676C426.279 181.89 426.063 182.098 425.844 182.302C416.074 191.782 400.477 191.689 390.821 182.023L270.737 61.8037L43.119 289.676Z",
    fill: "url(#paint0_linear_374_7612)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 545.5,
    cy: 27,
    r: 20,
    transform: "rotate(-90 545.5 27)",
    fill: "#232333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_7612",
    x1: 0.5,
    y1: 159.322,
    x2: 571.5,
    y2: 159.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57E5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ADABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.e2e6bf5b69f96b50fd190de5f2a70091.svg";
export { ForwardRef as ReactComponent };